import escape from 'lodash/escape';
import isNumber from 'lodash/isNumber';
import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';

export const getFieldNamePlugin = (
  nameImage: HTMLImageElement,
  imageWidth: number,
  isExport: boolean,
): any => ({
  id: 'fieldName',
  afterDraw(chart: any): void {
    const hasData = chart.data.datasets.some(
      (dataset) =>
        dataset.data &&
        dataset.data.length > 0 &&
        dataset.data.some((value) => isNumber(value) && value > 0),
    );

    if (!hasData) {
      return;
    }

    const { ctx, chartArea } = chart;
    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#999';

    const chartCenter = (chart.chartArea.left + chart.chartArea.right) / 2;
    let imagePosition = chartCenter - imageWidth / 2;
    if (imagePosition < 0) {
      imagePosition = 0;
    }

    ctx.drawImage(nameImage, imagePosition, chartArea.top - (isExport ? 100 : 20));

    ctx.restore();
  },
});

export function createNameElement(
  listFieldName: string,
  numericFieldName: string,
  isExport: boolean,
  listImage: string,
  numericalImage: string,
  arrowsImage: string,
  fontFaceCss: string,
): string {
  const fontSize = isExport ? 12 * 3.5 : 12;
  const font = `${fontSize}px ${getFontFamily()}`;
  const numericFieldNameWithEscapeCharacers = escape(numericFieldName);
  const listFieldNameWithEscapeCharacers = escape(listFieldName);

  const html = `
    <div
      xmlns="http://www.w3.org/1999/xhtml"
      style="
        font: ${font};
        color: #667085;
        display: flex;
        flex-direction: row;
        gap: 8px;
        white-space: nowrap;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
      "
    >
      <div style="display: flex; flex-direction: row; gap: 4px;">
        <img
          src="data:image/svg+xml;utf8,${encodeURIComponent(listImage)}"
          alt="List Field"
          style="width: ${isExport ? 14 * 3.5 : 14}px; height: ${isExport ? 14 * 3.5 : 14}px; vertical-align: middle;"
          class="calculate-width-image"
        />
        <span class="calculate-width-image">${listFieldNameWithEscapeCharacers}</span>
      </div>

      <img
        src="data:image/svg+xml;utf8,${encodeURIComponent(arrowsImage)}"
        alt="Arrows"
        style="width: ${isExport ? 14 * 3.5 : 14}px; height: ${isExport ? 14 * 3.5 : 14}; vertical-align: middle;"
        class="calculate-width-image"
      />

      <div style="display: flex; flex-direction: row; gap: 4px;">
        <img
          src="data:image/svg+xml;utf8,${encodeURIComponent(numericalImage)}"
          alt="Numerical Field"
          style="width: ${isExport ? 14 * 3.5 : 14}px; height: ${isExport ? 14 * 3.5 : 14}px; vertical-align: middle;"
          class="calculate-width-image"
        />
        <span class="calculate-width-image">${numericFieldNameWithEscapeCharacers}</span>
      </div>
    </div>
  `;

  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="${isExport ? 60 : 14}">
      <style type="text/css">${fontFaceCss}</style>
      <foreignObject width="100%" height="100%">
        ${html}
      </foreignObject>
    </svg>`;

  const encoded = encodeURIComponent(svgString);
  return `data:image/svg+xml;charset=utf-8,${encoded}`;
}
